var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2292 9C13.6549 9 14 8.65489 14 8.22918L14 2L7.77082 2C7.34511 2 7 2.34511 7 2.77082C7 3.19653 7.34511 3.54164 7.77082 3.54164L12.4584 3.54164L12.4584 8.22918C12.4584 8.65489 12.8035 9 13.2292 9Z",
    fill: "#8082C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77082 7C2.34511 7 2 7.34511 2 7.77082L2 14L8.22918 14C8.65489 14 9 13.6549 9 13.2292C9 12.8035 8.65489 12.4584 8.22918 12.4584L3.54164 12.4584L3.54164 7.77082C3.54164 7.34511 3.19653 7 2.77082 7Z",
    fill: "#8082C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/showMore.44661e2d8afb99540b05e3c3f4b68989.svg";
export { ForwardRef as ReactComponent };